import React from "react";
import TopBar from "./TopBar";
import {
  Button,
  Container,
  GlowingText,
  MainText,
  Subheading,
  TextLink,
} from "./common/common";
import { styled } from "styled-components";
import Spacer from "./common/Spacer";
import WaterlooSunset from "../assets/femtech_image.jpeg";
import { useNavigate } from "react-router-dom";

const SunsetImage = styled.img`
  width: 100%;
  height: auto;
  border-radius: 10px;
`;

const BulletList = styled.ul``;
const OrderedBulletList = styled.ol``;
const Bullet = styled.li``;

const About: React.FC = () => {
  const navigate = useNavigate();
  return (
    <>
      <TopBar />
      <Container>
        <GlowingText>velocity diaries</GlowingText>
        <MainText>
          Calling all student entrepreneurs, innovators, and creators!
        </MainText>
        <MainText>
          We are excited to launch our new "Velocity Diaries" project,
          showcasing the incredible work happening across our campus. Whether
          you are crafting an innovative product, building the next big app, or
          brainstorming your million-dollar idea, we want to see it!
        </MainText>
        <MainText>
          This project is proudly powered by{" "}
          <TextLink href="https://sunsetdiaries.com/">sunset diaries</TextLink>{" "}
          -- a platform for sunset enthusiasts to share their sunset photos,
          created by Grace Gao. We extend our heartfelt gratitude to Grace,
          whose expertise and dedication were instrumental in bringing this
          project to life.
        </MainText>
        <MainText>
          <Subheading>What We're Looking For</Subheading>
          <BulletList>
            <Bullet>Action shots of you working on your startup</Bullet>
            <Bullet>
              Behind-the-scenes glimpses of your project development
            </Bullet>
            <Bullet>
              Photos of your prototypes, MVP or products Team meetings or
              collaborative moments
            </Bullet>
            <Bullet>
              Any image that captures the spirit of student innovation
            </Bullet>
          </BulletList>
        </MainText>
        <MainText>
          <Subheading>How It Works</Subheading>
          <OrderedBulletList>
            <Bullet>
              Submit your best photos through our easy online form
            </Bullet>
            <Bullet>
              We'll select photos to print out and display in our community room
              (aka the Dungeon) at MC 2037
            </Bullet>
            <Bullet>
              Your work will inspire fellow students and visitors alike
            </Bullet>
          </OrderedBulletList>
        </MainText>
        <MainText>
          <Subheading>Why Participate?</Subheading>
          <BulletList>
            <Bullet>Gain exposure for your startup or project</Bullet>
            <Bullet>
              Connect with like-minded students Inspire others with your
              entrepreneurial journey
            </Bullet>
            <Bullet>Be part of our vibrant campus innovation showcase</Bullet>{" "}
          </BulletList>
        </MainText>
        <Spacer height={1} />
        <SunsetImage src={WaterlooSunset} />
        <Spacer height={0.5} />
        <MainText>
          Don't be shy – your photo could be the spark that ignites someone
          else's great idea! Submit your snapshots today and let's celebrate the
          amazing work happening right here on campus. Ready to share your
          story? Click below to submit your photos and be part of our gallery!
        </MainText>
        <Spacer height={0.5} />
        <Button onClick={() => navigate("/new")}>share your photos!</Button>
        <Spacer height={1.5} />
      </Container>
    </>
  );
};

export default About;
